/** Display identity only; never substitute a brand name into a social handle. */
export function postPreviewAuthor(post, brandProfileId, brands, fallbackName) {
  if (post?.handle) return { authorName: post.handle, authorLogoUrl: null };
  const brand = brandProfileId && Array.isArray(brands)
    ? brands.find(item => item.id === brandProfileId) : null;
  return {
    authorName: brand?.name?.trim() || fallbackName,
    authorLogoUrl: brand?.logoUrl || null,
  };
}
